import * as t from "io-ts";
import { CampaignEvent } from "./CampaignEvent";
import { Metadata } from "./Metadata";
import { UTM } from "./UTM";

export const Campaign = t.intersection([
  t.type({
    id: t.string,
    sid: t.string,
    event_name: CampaignEvent,
    referrer: t.string,
    gclid: t.string,
    metadata: Metadata,
  }),
  t.partial({
    cid: t.string,
    eid: t.string,
    bid: t.string,
    aid: t.string,
    oid: t.string,
    utm: UTM,
  }),
]);

export interface Campaign {
  id: string;
  sid: string;
  cid?: string;
  eid?: string;
  bid?: string;
  aid?: string;
  oid?: string;
  event_name: CampaignEvent;
  referrer: string;
  gclid: string;
  utm?: UTM;
  metadata: Metadata;
}
